module.exports = __webpack_public_path__ + "assets/fonts/iconfont.731b5c53.woff2";